import SectionLayout from '@/Layout/SectionLayout';
import VerificationPageLayout from '@/Layout/VerificationPageLayout';
import SwitchMfaFactorsLink from '@/components/SwitchMfaFactorsLink';
import TotpCodeVerification from '@/containers/TotpCodeVerification';
import useMfaFlowState from '@/hooks/use-mfa-factors-state';
import ErrorPage from '@/pages/ErrorPage';
import { UserMfaFlow } from '@/types';

import styles from './index.module.scss';

const TotpVerification = () => {
  const flowState = useMfaFlowState();

  if (!flowState) {
    return <ErrorPage title="error.invalid_session" />;
  }

  return (
    <VerificationPageLayout title="mfa.verify_mfa_factors">
      <div data-testid="mfa_container_totp_verification">
        <SectionLayout
          title="mfa.enter_one_time_code"
          description="mfa.enter_one_time_code_description"
        >
          <TotpCodeVerification flow={UserMfaFlow.MfaVerification} />
        </SectionLayout>
        <SwitchMfaFactorsLink
          flow={UserMfaFlow.MfaVerification}
          flowState={flowState}
          className={styles.switchFactorLink}
        />
      </div>
    </VerificationPageLayout>
  );
};

export default TotpVerification;
